var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/** Mismos textos que usa la vista de exportación del componente */
var LABELS = {
    exportTitle: "Historial de Envío de Correos",
    exportCertificate: "Certificado",
    exportPrintedAt: "Impresión",
    exportColCertificate: "No. de certificado",
    exportColUser: "Usuario",
    exportColUserName: "Nombre de usuario",
    exportColDate: "Fecha de acción",
    exportColEmail: "Correo electrónico",
    exportColOrigin: "Origen",
    exportColAction: "Acción realizada",
    exportColObservation: "Observación de acción",
};
/** Mismos colores y tipografías que la vista de exportación (style.js del componente) */
var MONO = "'Roboto Mono','Courier New',monospace";
var HEAD_BG = "#2E3B4E";
var CELL_BORDER = "#E9EAEE";
var TEXT = "#333333";
var META_TEXT = "#8C8C8C";
var COLUMNS = [
    { label: LABELS.exportColCertificate, width: 130, mono: true },
    { label: LABELS.exportColUser, width: 105, mono: false },
    { label: LABELS.exportColUserName, width: 155, mono: false },
    { label: LABELS.exportColDate, width: 150, mono: true },
    { label: LABELS.exportColEmail, width: 175, mono: true },
    { label: LABELS.exportColOrigin, width: 85, mono: false },
    { label: LABELS.exportColAction, width: 210, mono: false },
    { label: LABELS.exportColObservation, width: 380, mono: false },
];
var escapeHtml = function (value) {
    return String(value !== null && value !== void 0 ? value : "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
};
var headCellStyle = [
    "border:1px solid ".concat(HEAD_BG),
    "background-color:".concat(HEAD_BG),
    "color:#FFFFFF",
    "padding:8px 10px",
    "font-size:10pt",
    "font-weight:600",
    "text-align:left",
    "vertical-align:top",
].join(";");
var bodyCellStyle = function (mono) {
    return [
        "border:1px solid ".concat(CELL_BORDER),
        "padding:8px 10px",
        "font-size:11pt",
        "color:".concat(TEXT),
        "vertical-align:top",
        mono ? "font-family:".concat(MONO) : "",
        // Evita que Excel reinterprete fechas y códigos como número o fecha propia
        "mso-number-format:'\\@'",
    ]
        .filter(Boolean)
        .join(";");
};
/**
 * Aplana la traza del historial de correos (una fila por acción) y la descarga
 * con el mismo encabezado, columnas, orden, colores y tipografías que la vista
 * de exportación que muestra el componente.
 *
 * Se genera como HTML con estilos en línea y extensión .xls: es el único formato
 * que conserva el diseño sin agregar una dependencia de Excel al bundle.
 */
export var downloadMailHistoryExcel = function (items, certificate, printedAt) {
    /** Los envíos llegan del más reciente al más antiguo; el reporte se imprime en orden cronológico */
    var rows = __spreadArray([], items, true).reverse().flatMap(function (item) {
        var _a;
        return ((_a = item.trace) !== null && _a !== void 0 ? _a : []).map(function (step) { return [
            certificate,
            item.userCode,
            item.userName,
            [item.date, step.time].filter(Boolean).join(" "),
            item.email,
            item.origin,
            step.action,
            step.observation,
        ]; });
    });
    var meta = [
        certificate && "".concat(LABELS.exportCertificate, " ").concat(certificate),
        printedAt && "".concat(LABELS.exportPrintedAt, " ").concat(printedAt),
    ]
        .filter(Boolean)
        .join("  ·  ");
    var colGroup = COLUMNS.map(function (column) { return "<col style=\"width:".concat(column.width, "px\" />"); }).join("");
    var headRow = COLUMNS.map(function (column) {
        return "<th style=\"".concat(headCellStyle, "\">").concat(escapeHtml(column.label.toUpperCase()), "</th>");
    }).join("");
    var bodyRows = rows
        .map(function (row) {
        return "<tr>".concat(row
            .map(function (cell, index) {
            return "<td style=\"".concat(bodyCellStyle(COLUMNS[index].mono), "\">").concat(escapeHtml(cell), "</td>");
        })
            .join(""), "</tr>");
    })
        .join("");
    var html = "<html xmlns:x=\"urn:schemas-microsoft-com:office:excel\">\n<head>\n<meta charset=\"utf-8\" />\n<!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>\n<x:Name>Historial de correos</x:Name>\n<x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>\n</x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->\n</head>\n<body>\n<table style=\"border-collapse:collapse\">".concat(colGroup, "\n<tr><td colspan=\"").concat(COLUMNS.length, "\" style=\"font-size:15pt;font-weight:600;color:").concat(TEXT, ";padding:6px 0\">").concat(escapeHtml(LABELS.exportTitle), "</td></tr>\n<tr><td colspan=\"").concat(COLUMNS.length, "\" style=\"font-family:").concat(MONO, ";font-size:11pt;color:").concat(META_TEXT, ";padding:0 0 10px\">").concat(escapeHtml(meta), "</td></tr>\n<tr>").concat(headRow, "</tr>\n").concat(bodyRows, "\n</table>\n</body>\n</html>");
    // BOM para que Excel respete los acentos
    var blob = new Blob(["\uFEFF".concat(html)], {
        type: "application/vnd.ms-excel;charset=utf-8;",
    });
    var url = URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.href = url;
    link.download = "historial-correos-".concat(certificate || "poliza", ".xls");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
